import { Modal } from "react-bootstrap";
import ThemeButton from "../../../components/theme/ThemeButton";
import styles from "./GetPaidModal.module.scss";
import getPaid from '../../../assests/payout.jpg'

interface IProps {
    show: boolean;
    handleClose: () => void;
    onStripeClick: () => void;
    loading?: boolean;
}

const GetPaidModal = ({ show, handleClose, onStripeClick, loading }: IProps) => {
    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="lg"
            className={styles.getPaidModal}
            centered
        >
            <Modal.Body>
                <div className={styles.modalContent}>
                    <img src={getPaid} alt="getPaid" width={100} height={100} />
                    <div className={styles.modalTitle}>
                        <h2>Configure Your Payout Account</h2>
                        <h4>
                            You must setup your Stripe Payout Account in order to receive a payout. If you’ve just setup your account, please wait a few moments and try again. If you need help, please message us at <a href='mailto:support@toptipper.co ' >support@toptipper.co</a>
                        </h4>
                    </div>
                    <Modal.Footer className={styles.FooterModal}>
                        <ThemeButton
                            variant="secondary"
                            className="primary commonBtn"
                            onClick={handleClose}
                        >
                            Cancel
                        </ThemeButton>
                        <ThemeButton
                            variant="primary"
                            className="primary footerModalBtn commonBtn"
                            onClick={onStripeClick}
                            loading={loading}
                            style={{ whiteSpace: 'nowrap' }}
                        >
                            Setup Stripe
                        </ThemeButton>
                    </Modal.Footer>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default GetPaidModal; 